import { render, staticRenderFns } from "./Get.vue?vue&type=template&id=3637fe28&scoped=true"
import script from "./Get.vue?vue&type=script&lang=js"
export * from "./Get.vue?vue&type=script&lang=js"
import style0 from "./Get.vue?vue&type=style&index=0&id=3637fe28&prod&lang=scss&scoped=true"
import style1 from "./Get.vue?vue&type=style&index=1&id=3637fe28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637fe28",
  null
  
)

export default component.exports